import Vue from "vue/dist/vue.esm.js";
const EventBus = new Vue();
export { EventBus };
